import ApplicationDocumentForm from '../../components/ApplicationDocComps/ApplicationDocumentForm';
import PageHeader from '../../components/CommonComps/Titles/PageHeader';
import PageTitle from '../../components/CommonComps/Titles/PageTitle';

const ApplicationDocuments = () => {
  // rendering application document page component here
  return (
    <main className='font-lato w-[95%] md:w-4/5 2xl:w-3/5 max-w-[1500px] mx-auto py-14'>
      <PageTitle title='Application Documents' />

      <PageHeader headerText={`Associate's application`} />

      <ApplicationDocumentForm />
    </main>
  );
};

export default ApplicationDocuments;
